import { render, staticRenderFns } from "./ServiceProposalDetails.vue?vue&type=template&id=773bdabc&scoped=true"
import script from "./ServiceProposalDetails.vue?vue&type=script&lang=js"
export * from "./ServiceProposalDetails.vue?vue&type=script&lang=js"
import style0 from "./ServiceProposalDetails.vue?vue&type=style&index=0&id=773bdabc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773bdabc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773bdabc')) {
      api.createRecord('773bdabc', component.options)
    } else {
      api.reload('773bdabc', component.options)
    }
    module.hot.accept("./ServiceProposalDetails.vue?vue&type=template&id=773bdabc&scoped=true", function () {
      api.rerender('773bdabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/ServiceProposalDetails.vue"
export default component.exports